<template>
  <div class="page page--home">
    <div class="container">
      <div>
        <h1 class="ascenti">Symptom checker</h1>
        <p class="home-page-intro">To find out how physio could help you, answer a few questions about your injury, and we will:</p>
        
        <div class="icon-bullet">
          <img class="icon-bullet__icon" src="../assets/img/icons/tick.svg" alt="" />
          <p class="icon-bullet__copy">Check that physio is right for you</p>
        </div>
        <div class="icon-bullet">
          <img class="icon-bullet__icon" src="../assets/img/icons/days.svg" alt="" />
          <p class="icon-bullet__copy">Help you pinpoint the correct type of appointment</p>
        </div>
        <div class="icon-bullet">
          <img class="icon-bullet__icon" src="../assets/img/icons/share.svg" alt="" />
          <p class="icon-bullet__copy">Share your responses with your physio so they can give you the best treatment</p>
        </div>

        <div class="btn-container">
          <router-link class="button start-button" :to="routes.step1">
            <span>Start now</span>
          </router-link>
        </div>

        <div class="terms">
          <p>By clicking start you agree to the terms below</p>
          <p>I'm over 18 years old.</p>
          <p>As far as I know, I don't need urgent or emergency treatment.</p>
          <p>I acknowledge that the Terms of Service contain important information about the scope of the services you provide (and the reliance that I should place on those services) and I agree to such Terms of Service</p>
        </div>
      </div>

      <div>
        <div class="img-quote">
          <img class="img-quote__img" src="../assets/img/homepage-physio.jpg" alt="" />
          <div class="img-quote__quote">
            <img class="img-quote__icon img-quote__icon--open" src="../assets/img/icons/quote.svg" alt="" />
            Our team of highly-trained physiotherapists will be with you every step of the way, helping you to make the right treatment choices and get back to your best.
            <img class="img-quote__icon img-quote__icon--closed" src="../assets/img/icons/quote.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex"

export default {
  computed: {
    ...mapState("survey", [
      "currentStep",
      "totalSteps",
      "needsAppointment",
    ]),
  },

  mounted() {
    this.$gtm.trackView('Homepage', '/');

    this.scrollToTop();
  },
}
</script>

<style lang="scss">

  .page--home {
    .container {
      color: $color-dove-gray;
      display: flex;
      font-size: 20px;

      > div {
        flex-basis: 100%;

        &:nth-child(1) {          
          @include screen(md) {
            margin-right: 40px;
          }

          @include screen(lg) {
            margin-right: 80px;
          }
        }

        &:nth-child(2) {
          display: none;

          @include screen(md) {
            display: block;
            margin-left: 40px;
          }

          @include screen(lg) {
            margin-left: 80px;
          }
        }
      }

      h1 {
        margin-bottom: 16px;
      }

      .btn-container {
        text-align: center;

        @include screen(md) {
          text-align: left;
        }
      }

      .home-page-intro {
        margin-bottom: 40px;
      }

      .icon-bullet {
        font-size: 16px;
        display: flex;
        align-items: center;
        margin-bottom: 13px;

        &__copy {
          margin-bottom: 5px;
          margin-top: 5px;
        }

        &__icon {
          margin-right: 13px;
          max-width: 16px;
          height: auto;
        }
      }

      .start-button {
        margin-top: 17px;

        @include screen(md) {
          margin-top: 37px;
        }
      }

      .terms {
        margin-top: 35px;

        p {
          opacity: 0.5;
          font-size: 14px;
          margin-bottom: 25px;
          line-height: 18px;
        }
      }

      .img-quote {
        &__quote {
          background: rgba($color-botticelli, 0.6);
          color: $color-chathams-blue;
          font-size: 28px;
          line-height: 1.2;
          padding: 28px 19px 19px 19px;
          max-width: 441px;
          position: relative;

          div {
            font-size: 14px;
            margin-top: 12px;
          }
        }

        &__img {
          display: block;
          max-width: 100%;
        }

        &__icon {
          position: absolute;

          &--open {
            top: -24px;
          }
          
          &--closed {
            transform: rotate(180deg);
            bottom: -24px;
            right: 19px;
          }
        }
      }
    }
  }

</style>
